// Loại bỏ import cache từ react để tránh xung đột
// import { cache } from 'react';

interface DataServiceConfig {
  baseUrl?: string;
  useRemote?: boolean;
}

class DataService {
  private baseUrl: string;
  private useRemote: boolean;
  private cache: Map<string, any>;

  constructor(config: DataServiceConfig = {}) {
    this.baseUrl = config.baseUrl || '/data/json';
    this.useRemote = config.useRemote || false;
    this.cache = new Map();
  }

  private getUrl(path: string): string {
    if (this.useRemote) {
      return `${this.baseUrl}/${path}`;
    }
    return `/data/json/${path}`;
  }

  private async fetchWithCache(url: string) {
    if (this.cache.has(url)) {
      return this.cache.get(url);
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      this.cache.set(url, data);
      return data;
    } catch (error) {
      console.error(`Error fetching data from ${url}:`, error);
      throw error;
    }
  }

  public async getData(path: string) {
    const url = this.getUrl(path);
    return this.fetchWithCache(url);
  }

  public clearCache() {
    this.cache.clear();
  }

  public removeFromCache(path: string) {
    const url = this.getUrl(path);
    this.cache.delete(url);
  }
}

// Create a singleton instance with default config
const dataService = new DataService();

// Sử dụng cơ chế cache nội bộ của DataService thay vì React.cache
export const getCachedData = async (path: string) => {
  return dataService.getData(path);
};

export default dataService; 